export const isEmptyOrNull = (data) => {
    return data === '' || data === null || data === undefined
}

export const isNormalSchool = (branch) => {
    var isNormal = true;
    if (!isEmptyOrNull(branch)) {
        if(!isEmptyOrNull(branch.settings)){
            branch.settings.forEach(it => {
                if (it.name === "COLLEGE_TYPE"){
                if(it.value === "T"){
                    isNormal = true
                }else{
                    isNormal = false
                }
                }
            })   
        }
    }
    return isNormal
}

export const getLevelGGIds = ( branch ) => {
    if (!isEmptyOrNull(branch.defaultLevel) && !isEmptyOrNull(branch.defaultGG)){
        return { idLevel: branch.defaultLevel, idGG: branch.defaultGG }
    } else {
        return undefined
    }
}

export const getMessageError = (data) => {
    if (isEmptyOrNull(data)){
        return "Ups, ocurrió un error"; 
    }else{
        switch (data.code) {
            case 1129:
                return "Por el momento no se puede actualizar el comunicado, inténtelo más tarde" 
            case 1130:
                return "Es necesario seleccionar un colaborador para el día de asueto" 
            case 1131:
                return "Salón no encontrado o la petición es incorrecta" 
            case 1132:
                return "El día de asueto ya existe" 
            case 1133:
                return "El salón de clases está asignado a un curso" 
            case 1134:
                return "Cambio de estatus incorrecto" 
            case 1035:
                return "Error al registrar la asistencia"
            default:
                return "Ups, ocurrió un error";
        }
    }
}